import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type OpenLetterRequestMutationVariables = Types.Exact<{
  questionId: Types.Scalars['Int']
}>

export type OpenLetterRequestMutation = {
  __typename?: 'Mutation'
  openLetterRequest: { __typename?: 'LetterRequest'; id: number }
}

export const OpenLetterRequestDocument = gql`
  mutation OpenLetterRequest($questionId: Int!) {
    openLetterRequest(questionId: $questionId) {
      id
    }
  }
`
export type OpenLetterRequestMutationFn = ApolloReactCommon.MutationFunction<
  OpenLetterRequestMutation,
  OpenLetterRequestMutationVariables
>
export function useOpenLetterRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OpenLetterRequestMutation,
    OpenLetterRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    OpenLetterRequestMutation,
    OpenLetterRequestMutationVariables
  >(OpenLetterRequestDocument, options)
}
export type OpenLetterRequestMutationHookResult = ReturnType<typeof useOpenLetterRequestMutation>
export type OpenLetterRequestMutationResult =
  ApolloReactCommon.MutationResult<OpenLetterRequestMutation>
export type OpenLetterRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<
  OpenLetterRequestMutation,
  OpenLetterRequestMutationVariables
>
